import React, { useState } from "react";
import { Box, IconButton, Typography, TextField, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export function CustomFileUpload({
  onChange,
  fileType,
  label = "Input",
  name,
  isEdit = true,
}) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreviewUrl(URL.createObjectURL(selectedFile)); // Generate preview URL
      onChange(e); // Notify the parent about file change
    }
  };

  const handleFileRemove = () => {
    setFile(null);
    setPreviewUrl(null);
    onChange({target:{
      name:name,
      type:'file',
      files:[null]
    }}); // Notify the parent about file removal
  };

  const fileAccept = fileType === "image" ? "image/*" : "application/pdf";

  return (
    <Box>
      <Typography
        variant="body1"
        color="initial"
        sx={{ color: "#646464", fontWeight: "500" }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          border: "2px dashed #ccc",
          borderRadius: "5px",
          padding: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
          width: "100%",
          height: "150px",
          backgroundColor: "#f9f9f9",
          position: "relative",
        }}
      >
        {file ? (
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* Show Preview for Image or PDF */}
            {fileType === "image" ? (
              <img
                src={previewUrl}
                alt="Uploaded "
                style={{
                  maxWidth: "85%",
                  maxHeight: "85%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <iframe
                src={previewUrl}
                title="PDF Preview"
                style={{
                  width: "85%",
                  height: "95%",
                  border: "none",
                }}
              ></iframe>
            )}

            {/* Delete Icon */}
            <IconButton
              color="error"
              size="small"
              onClick={handleFileRemove}
              sx={{
                position: "absolute",
                top: "-20px",
                right: "-20px",
                color: "red",
                display: isEdit ? "inline-block" : "none",
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                "&:hover": { backgroundColor: "rgba(255, 255, 255, 1)" },
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        ) : (
          <label
            htmlFor={`file-${name}`}
            style={{
              cursor: "pointer",
              color: "#007bff",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            {fileType === "image" ? "Upload an image" : "Upload a PDF"}
          </label>
        )}

        <input
          type="file"
          id={`file-${name}`}
          name={name}
          disabled={!isEdit}
          accept={fileAccept}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </Box>
    </Box>
  );
}

export function CustomFileUploadLikeSelect({
  onChange,
  label = "Upload File",
  isEdit = true,
}) {
  const [fileName, setFileName] = useState(""); // Stores file name

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFileName(selectedFile.name); // Update file name
      onChange(selectedFile); // Notify parent about the selected file
    }
  };

  const handleFileRemove = () => {
    setFileName(""); // Reset file name
    onChange(null); // Notify parent about file removal
  };

  return (
    <Box>
      <Typography
        variant="body1"
        sx={{ color: "#646464", fontWeight: "500", marginBottom: 1 }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "2px 6px",
        }}
      >
        <TextField
          value={fileName}
          variant="outlined" // Use 'outlined' for better control
          placeholder="No file chosen"
          InputProps={{
            readOnly: true,
            sx: {
              height: "45px", // Set the height for the input field
              fontWeight: 500, // Adjust font weight
             
            },
          }}
          sx={{
            flex: 1,
            color: "#313131",
            fontWeight: "500",
            marginBottom: "0px",
            "& .MuiInputBase-root": {
              height: "38px", // Ensure height consistency
            },
            "& .MuiInputBase-input": {
              fontWeight: 500,
              padding: "5px", // Ensure padding consistency
            },
            "& fieldset": { border: "none" }, // Remove border completely
          }}
        />
        {fileName && (
          <IconButton
            color="error"
            onClick={handleFileRemove}
            disabled={!isEdit}
            sx={{
              display: isEdit ? "inline-flex" : "none",
            }}
          >
            <DeleteIcon />
          </IconButton>
        )}
        <Button
          variant="contained"
          component="label"
          size="small"
          disabled={!isEdit}
          sx={{
            textTransform: "none",
            boxShadow:"none",
            py: 0,
            my: 0,
            backgroundColor: "#80B8EC",
            "&:hover": { backgroundColor: "#0056b3" },
          }}
        >
          Choose file
          <input
            type="file"
            hidden
            onChange={handleFileChange}
            accept="image/*,application/pdf"
          />
        </Button>
      </Box>
    </Box>
  );
}
